module.exports = __webpack_public_path__ + "img/play-off.8306cb20.png";